export default {
	sentenceLength: {
		recommendedWordCount: 15,
	},
	fleschReading: {
		borders: {
			veryEasy: 80,
			easy: 70,
			fairlyEasy: 60,
			okay: 50,
			fairlyDifficult: 40,
			difficult: 20,
		},
	},
};
